/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDashboardFileDetailsFromDiscriminatorValue, type DashboardFileDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/GetDetails
 */
export interface GetDetailsRequestBuilder extends BaseRequestBuilder<GetDetailsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DashboardFileDetails[]>}
     */
     get(requestConfiguration?: RequestConfiguration<GetDetailsRequestBuilderGetQueryParameters> | undefined) : Promise<DashboardFileDetails[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetDetailsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetDetailsRequestBuilderGetQueryParameters {
    bookingNumber?: string;
    passengerDataFileId?: number;
}
/**
 * Uri template for the request builder.
 */
export const GetDetailsRequestBuilderUriTemplate = "{+baseurl}/Dashboard/GetDetails?bookingNumber={bookingNumber}&passengerDataFileId={passengerDataFileId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetDetailsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetDetailsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDashboardFileDetailsFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
